function showCookieBar(){
    let cookieBar = document.getElementById("cookie-bar");
    cookieBar.style.display = "block";
}
function hideCookieBar(){
    localStorage.setItem("isCookieAccepteds", "yes");

    let cookieBar = document.getElementById("cookie-bar");
    cookieBar.style.display = "none";
}
function initializeCookieBar(){
    let isCookieAccepted = localStorage.getItem("isCookieAccepteds");
    if(isCookieAccepted === null)
    {
        localStorage.setItem("isCookieAccepteds", "no");
        showCookieBar();
    }
    if(isCookieAccepted === "no"){
        showCookieBar();
    }
}
window.onload = initializeCookieBar();
window.cb_hideCookieBar = hideCookieBar;
